import { render, staticRenderFns } from "./adminModal.vue?vue&type=template&id=9f25b2bc&"
import script from "./adminModal.vue?vue&type=script&lang=js&"
export * from "./adminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports